__turbopack_context__.v({
  "WithNumberCard": "brightway-by-the-numbers-module-scss-module__PSkKiW__WithNumberCard",
});
